import { createSlice } from "@reduxjs/toolkit";
import { buyMiner,sellMiner, getMinersOwned, activateMiner } from "./MinersOwnedActions";

const initialState = {
    loading: false,
    minersOwned: [], // for minersOwned array
    error: null,
    success: false, // for monitoring the registration process.
  }

const minersOwnedSlice = createSlice({
    name: "minersOwned",
    initialState,
    reducers: {},
    extraReducers:{
        [getMinersOwned.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.minersOwned = payload.data
        },
        [getMinersOwned.pending]: (state, {payload}) => {
            state.loading = true
        },
        [getMinersOwned.rejected]: (state, {payload}) => {
            state.loading = false
            state.minersOwned = payload
        },
        [buyMiner.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
        },
        [buyMiner.pending]: (state, {payload}) => {
            state.loading = true
        },
        [buyMiner.rejected]: (state, {payload}) => {
            state.loading = false
        },
        [sellMiner.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
        },
        [sellMiner.pending]: (state, {payload}) => {
            state.loading = true
        },
        [sellMiner.rejected]: (state, {payload}) => {
            state.loading = false
        },
        [activateMiner.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
        },
        [activateMiner.pending]: (state, {payload}) => {
            state.loading = true
        },
        [activateMiner.rejected]: (state, {payload}) => {
            state.loading = false
        }
    }
})

export default minersOwnedSlice.reducer